<template>
  <div>
    <top-header :type="12" :placeholder="keyWord"  @comfirmText="comfirmText"/>
    <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
    <van-overlay :show="Boolean(projectList.length)">
    </van-overlay>
    <div style="text-align:center;padding-top:30%;font-size:16px">
      该功能正在升级中
    </div>
    <div class="wrapper" v-show="Boolean(projectList.length)" v-if="flase">
      <div class="select_con">
        <div class="m_flex_box flex_vc flex_jz row" v-for="(item, index) in projectList" :key="index">
          <p class="left line_comp1" @click="setProjectName(item)">{{item.tgmc}}({{item.xmmc}})</p>
        </div>
      </div>
    </div>
    <div class="tab_con m_flex_box flex_jz" :class="showPad ? 'fixed' : ''" v-if="flase">
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showArea === true ? 'active' : ''" @click="setTab('showArea')">
          <span class="line_comp1">{{tabText.showArea ? tabText.showArea : '区域'}}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showArea">
            <p :class="formData.area === item.xzqh_code ? 'active' : ''" @click="setVal('area', item.xzqh_code, item.xzqh_name, 'showArea')"
                v-for="(item, index) in xzqhArray" :key="index">{{item.xzqh_name}}</p>
          </div>
        </transition>
      </div>

      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showPrice === true ? 'active' : ''" @click="setTab('showPrice')">
          <span class="line_comp1">{{tabText.showPrice ? tabText.showPrice : '价格'}}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="price_list inner_form" v-show="tab.showPrice">
            <div class="m_flex_box price_inner">
              <div class="left" @touchmove.prevent>
                <p class="active">总价</p>
              </div>
              <div class="right flex-1" v-show="priceType === 2">
                <p :class="formData.totalPrice === '' ? 'active' : ''" @click="setVal('totalPrice', '', '', 'showPrice')">不限</p>
                <div v-show="xzqhDefault==='320300'">
                  <p  :class="formData.totalPrice === item.value ? 'active' : ''" @click="setVal('totalPrice', item.value, item.text, 'showPrice')" v-for="(item, index) in totalPrice" :key="index">{{item.text}}</p>
                </div>
                <div v-show="xzqhDefault!=='320300'">
                  <p :class="formData.totalPrice === item.value ? 'active' : ''" @click="setVal('totalPrice', item.value, item.text, 'showPrice')" v-for="(item, index1) in totalPrice1" :key="index1">{{item.text}}</p>
                </div>
              </div>
            </div>
            <div class="bottom_con m_flex_box flex_vc flex_jz">
              <div class="m_flex_box flex_vc">
                <span class="tit">自定义</span>
                <input type="number" v-model="min"><i>-</i><input type="number" v-model="max"><p><span v-show="priceType === 2">万</span>元</p>
              </div>
              <van-button type="info" @click="priceConfirm">确定</van-button>
            </div>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showMj === true ? 'active' : ''" @click="setTab('showMj')">
          <span class="line_comp1">{{tabText.showMj ? tabText.showMj : '面积'}}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showMj">
            <p :class="formData.mj === '' ? 'active' : ''" @click="setVal('mj', '', '', 'showMj')">不限</p>
            <p :class="formData.mj === item.value ? 'active' : ''" @click="setVal('mj', item.value, item.text, 'showMj')" v-for="(item, index1) in totalMj" :key="index1">{{item.text}}</p>
          </div>
        </transition>
      </div>


      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showHouseUse === true ? 'active' : ''" @click="setTab('showHouseUse')">
          <span class="line_comp1">{{tabText.showHouseUse ? tabText.showHouseUse : '用途'}}</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="inner_list inner_form" v-show="tab.showHouseUse">
            <p :class="formData.houseUse === '' ? 'active' : ''" @click="setVal('houseUse', '', '', 'showHouseUse')">不限</p>
            <p :class="formData.houseUse === item.value ? 'active' : ''" @click="setVal('houseUse', item.value, item.text, 'showHouseUse')" v-for="(item, index1) in totalHouseUse" :key="index1">{{item.text}}</p>
          </div>
        </transition>
      </div>
      <div class="inner_con">
        <p class="text m_flex_box flex_vc flex_hc" :class="tab.showType === true ? 'active' : ''" @click="setTab('showType')">
          <span class="line_comp1">更多</span>
          <van-icon name="play" />
        </p>
        <transition name="slide-y" mode="out-in">
          <div class="more_list inner_form" v-show="tab.showType">
            <div class="more_con">
              <div class="row_con">
                <h4>装修状况</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span :class="formData.decoration === '0' ? 'active' : ''" @click="setValB('decoration', '0')">毛坯</span>
                  <span :class="formData.decoration === '1' ? 'active' : ''" @click="setValB('decoration', '1')">简装</span>
                  <span :class="formData.decoration === '2' ? 'active' : ''" @click="setValB('decoration', '2')">精装</span>
                </div>
              </div>
              <div class="row_con">
                <h4>层高</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span :class="formData.locationLayer ===  0 ? 'active' : ''" @click="setValB('locationLayer', 0)">低楼层</span>
                  <span :class="formData.locationLayer ===  1 ? 'active' : ''" @click="setValB('locationLayer', 1)">中楼层</span>
                  <span :class="formData.locationLayer ===  2 ? 'active' : ''" @click="setValB('locationLayer', 2)">高楼层</span>
                </div>
              </div>
              <div class="row_con">
                <h4>挂牌时间</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span :class="formData.listDate === '0' ? 'active' : ''" @click="setValB('listDate', '0')">一周内</span>
                  <span :class="formData.listDate === '1' ? 'active' : ''" @click="setValB('listDate', '1')">一月内</span>
                  <span :class="formData.listDate === '2' ? 'active' : ''" @click="setValB('listDate', '2')">三月内</span>
                </div>
              </div>
              <div class="row_con">
                <h4>户型</h4>
                <div class="row_inner m_flex_box flex_vc flex_vw">
                  <span :class="formData.room === '1' ? 'active' : ''" @click="setValB('room', '1')">一室</span>
                  <span :class="formData.room === '2' ? 'active' : ''" @click="setValB('room', '2')">两室</span>
                  <span :class="formData.room === '3' ? 'active' : ''" @click="setValB('room', '3')">三室</span>
                  <span :class="formData.room === '4' ? 'active' : ''" @click="setValB('room', '4')">四室</span>
                  <span :class="formData.room === '5' ? 'active' : ''" @click="setValB('room', '5')">五室</span>
                  <span :class="formData.room === '6' ? 'active' : ''" @click="setValB('room', '6')">六室</span>
                  <span :class="formData.room === '7' ? 'active' : ''" @click="setValB('room', '7')">七室</span>
                  <span :class="formData.room === '8' ? 'active' : ''" @click="setValB('room', '8')">八室</span>
                  <span :class="formData.room === '9' ? 'active' : ''" @click="setValB('room', '9')">九室</span>
                  <span :class="formData.room === '10' ? 'active' : ''" @click="setValB('room', '10')">十室</span>
                </div>
              </div>
            </div>
            <div class="m_flex_box flex_vc flex_jz btn_con">
              <button class="reset" @click="reset">重置</button>
              <button class="confirm" @click="confirm">确定</button>
            </div>
          </div>
        </transition>
      </div>

    </div>
    <div class="map_con" v-if="flase">
      <baidu-map class="bm-view"
        :center="center"
        :scroll-wheel-zoom="true"
        :zoom="zoom"
        :dragging="dragging"
        @ready="handler"
        @moving="moveMap"
        @zoomend="changeZoom"
        @dragstart="dragstart"
        @dragend="dragend"
      >
        <my-overlay
          v-for="(item, index) in showList" :key="index" :position="zoom <= 12 ? {lng: item.zb.jd, lat: item.zb.wd} : {lng: item.jd, lat: item.wd}"
          :info="item"
          :zoom="zoom"
          :check="checkNum"
          @click.native="setCheck(zoom <= 12 ? {lng: item.zb.jd, lat: item.zb.wd} : {lng: item.jd, lat: item.wd}, item.itemId, item)"
          >
        </my-overlay>
      </baidu-map>
      <div class="map_bottom old_list list_con" v-if="showInfo">
        <div class="map_tit_con">
          <div class="top m_flex_box flex_vc flex_jz">
            <div class="left m_flex_box flex_vc" @click="toURL(infoDetail.itemId, infoDetail.old,infoDetail.xzqh)">
              <h5 class="line_comp1">{{infoDetail.tgmc}}</h5>
              <van-icon name="arrow" />
            </div>
            <span class="more" @click="toMore(infoDetail.itemId, infoDetail.xzqh)">查看更多</span>
          </div>
          <div class="m_flex_box flex_vc bottom">
            <span>{{infoDetail.xzqhStr}}</span>
            <i>|</i>
            <span>在售套数：{{infoDetail.ksts}}</span>
            <p>均价 <span>{{infoDetail.priceStr}}元/m²</span></p>
          </div>
        </div>
        <div class="inner m_flex_box flex_vc" v-for="(item, index) in list" :key="index"  @click="toDetail('/houseDetail', {mainId:item.mainId,houseListedId:item.id})" >
          <div class="inner_l">
            <img class="banner" v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'">
          </div>
          <div class="new_r">
            <div class="m_flex_box flex_vc flex_jz tit">
              <h4 class="line_comp1">{{item.tgmc}}</h4>
              <i>在售</i>
            </div>
            <p class="line_comp1 col_gray">{{item.xzqh}} / {{item.zmjCount}}m² / {{item.room}}室{{item.hall}}厅</p>
            <div class="m_flex_box flex_jz">
              <div class="price m_flex_box flex_vb">
                <h4>{{item.listedPrice / 10000}}万</h4>
                <p>{{item.unitPrice}}元/平</p>
              </div>
            </div>
            <div class="num m_flex_box flex_vc">
              <img src="@/assets/img/check.png" alt=""><span>核验编码</span>{{item.uniqueCode}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aside" v-if="flase">
      <router-link to="/newMap">新房</router-link>
      <p>二手房</p>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header'
import MyOverlay from '@/components/myOverLayOld'
export default {
  data() {
    return {
      projectList: [],
      oneList: [],
      twoList: [],
      dragging: false,
      overList: [],
      checkNum: null,
      totalHouseUse: [{
        value: '住宅',
        text: '住宅'
      },{
        value: '商',
        text: '商服'
      },{
        value: '办',
        text: '办公'
      },{
        value: '车库',
        text: '车库'
      },{
        value: '地下室',
        text: '地下室'
      }],
      totalMj: [{
        value: '0-50',
        text: '50平米以下'
      },{
        value: '50-70',
        text: '50-70平米'
      },{
        value: '70-90',
        text: '70-90平米'
      },{
        value: '90-130',
        text: '90-130平米'
      },{
        value: '130-200',
        text: '130-200平米'
      },{
        value: '200-300',
        text: '200-300平米'
      },{
        value: '300-500',
        text: '300-500平米'
      },{
        value: '500-9999999',
        text: '500平米以上'
      }],
      totalPrice: [{
        value: '100000-1000000',
        text: '100万以下'
      },{
        value: '1000000-1500000',
        text: '100-150万元'
      },{
        value: '1510000-2000000',
        text: '151-200万元'
      },{
        value: '2010000-2500000',
        text: '201-250万元'
      },{
        value: '2510000-3000000',
        text: '251-300万元'
      },{
        value: '3010000-4000000',
        text: '301-400万元'
      },{
        value: '4000000-100000000',
        text: '400万以上'
      }],
      totalPrice1: [{
        value: '10000-500000',
        text: '50万以下'
      },{
        value: '510000-700000',
        text: '51-70万元'
      },{
        value: '710000-800000',
        text: '71-80万元'
      },{
        value: '810000-900000',
        text: '81-90万元'
      },{
        value: '910000-1000000',
        text: '91-100万元'
      },{
        value: '1010000-1200000',
        text: '101-120万元'
      },{
        value: '1200000-5000000',
        text: '120万以上'
      }],
      tab: {
        showArea: false,
        showPrice: false,
        showMj: false,
        showHouseUse:false,
        showType: false,
      },
      tabText: {
        showArea: '',
        showPrice: '',
        showMj: '',
        showHouseUse:'',
      },
      priceType: 2,
      formData: {
        area: this.main.getHostArea(),
        price: '',
        totalPrice: '',
        zjgq: '',
        zjgz: '',
        hx: '',
        lx: '',
        liftMark: '',
        houseAttribute: '',
        structType: '',
        zmjMin:'',
        zmjMax:'',
        houseUse:'',
        decoration:'',
        locationLayer:'',
        listDate:'',
        room:'',
        xmmc:'',
      },
      min: '',
      max: '',
      showPad: false,
      showCover: false,
      xzqhDefault:this.main.getHostArea(),
      xzqhArray:[],
      items:'',
      scale: 1,
      center: {lng:117.290722,lat:34.211547},
      zoom: 12,
      active: true,
      map: null,
      showList: [],
      timer: null,
      showInfo: false,
      infoDetail: {},
      keyWord: '',
      list: []
    };
  },
  components: {
    topHeader,
    MyOverlay
  },
  mounted() {
    this.getArea();
  },
  watch: {
    keyWord(n) {
      this.$set(this, 'projectList', [])
      const newArr = []
      this.twoList.forEach(function (item) {
        if ((item.tgmc.includes(n)|| item.xmmc.includes(n))) {
          newArr.push(item)
        }
      })
      this.$set(this, 'projectList', newArr);
      if(n === '') {
        this.$set(this, 'projectList', [])
      }
    }
  },
  methods: {
    getSaleList(itemId) {
      this.$http({
        url: 'cms/houseListed/permit/getHouseList.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          pageSize: 1,
          offset: 0,
          area: this.main.getHostArea(),
          itemId
        }
      }).then(res => {
        this.list = res.obj ? res.obj.rows : []
      })
    },
    toURL(itemId,old,xzqh){
      var area = this.main.getAreaCode(xzqh);
      if(this.$route.query.type === 'wx') {
        if (old == 1) {
          uni.navigateTo({
            url: `/pages/old/projectDetail?itemId=${itemId}`
          })
        } else {
          uni.navigateTo({
            url: `/pages/new/detail?itemId=${itemId}`
          })
        }
      } else {
        if(old==1){
          this.$router.push({
            path: '/projectDetailIndex',
            query: {
              itemId: itemId
            }
          })
        }else{
          this.$router.push({
            path: '/projectDetail',
            query: {
              itemId: itemId
            }
          })
        }
      }
    },

    toDetail(path,query) {
      this.$router.push({
        path,
        query
      })
    },

    toMore(itemId,xzqh) {
      this.$router.push({
        path: '/secondHouseList',
        query: {
          itemId:itemId,
          xzqh: this.main.getAreaCode(xzqh)
        }
      })
    },



    comfirmText(data) {
      this.keyWord = data
    },
    setCheck(center, id, item) {
      this.center = center;
      if(this.zoom <= 12) {
        this.zoom = 14;
      } else {
        this.checkNum = id;
        this.showInfo = true;
        this.infoDetail = item;
        this.getSaleList(item.itemId)
      }
    },
    setProjectName(info) {
      this.twoList.forEach(item => {
        if(item.itemId === info.itemId) {
          this.center = {lng: item.jd, lat: item.wd};
          this.checkNum = info.itemId;
          this.showInfo = true;
          this.infoDetail = item;
          this.getSaleList(item.itemId);
        }
      })
      setTimeout(() => {
        this.$set(this, 'projectList', []) ;
        this.getConernPoint();
      }, 10);
    },
    dragstart() {
      this.dragging = true;
    },
    dragend() {
      this.dragging = false;
    },
    getFirst() {
      this.$http({
        url: '/cms/houseListed/permit/getMapSearchM.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: this.formData
      }).then(res => {
        if(this.zoom <= 12) {
          this.overList = res.obj
        }
        this.oneList = res.obj;
        this.$http({
          url: '/cms/houseListed/permit/getMapSearchList.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: this.formData
        }).then(res => {
          if(this.zoom > 12) {
            this.overList = res.obj
            if(res.obj.length) {
              this.center = {lng: res.obj[0].jd, lat: res.obj[0].wd}
              setTimeout(() => {
                this.getConernPoint();
              }, 100);
            }
          }
          this.twoList = res.obj;
          this.getConernPoint();
        });
      });
    },
    changeZoom(type, target) {
      this.zoom = type.target.Za;
      console.log(type)
      if(this.zoom <= 12) {
        this.showInfo = false;
        // this.showInfo = true;
        this.$set(this, 'overList', this.oneList)
      } else {
        this.$set(this, 'overList', this.twoList);
      }
      setTimeout(() => {
        this.dragging = false;
        this.getConernPoint()
      }, 1);
    },
    moveMap() {
      this.getConernPoint()
    },
    getConernPoint() {
      return new Promise(resolve => {
        if(!this.timer) {
          if(this.map) {
            this.map.clearOverlays()
          let minPoint = this.map.getBounds().getSouthWest()
          let maxPoint = this.map.getBounds().getNorthEast()
          const newArr = [];
          if(this.zoom <= 12) {
            this.overList.forEach(item => {
              if(item.zb.wd <= maxPoint.lat && item.zb.wd >= minPoint.lat && item.zb.jd <= maxPoint.lng && item.zb.jd >= minPoint.lng) {
                newArr.push(item)
              }
            });
          } else {
            this.overList.forEach(item => {
            if(item.wd <= maxPoint.lat && item.wd >= minPoint.lat && item.jd <= maxPoint.lng && item.jd >= minPoint.lng) {
                newArr.push(item)
              }
            });
          }
          this.$set(this, 'showList', newArr);
          resolve({min: minPoint, max: maxPoint});
          this.timer = setTimeout(() => {
            this.timer = null;
          }, 20)
          }
        }
      })
    },
    handler ({BMap, map}) {
      this.map = map;
      this.dragging = true;
      this.getFirst()
    },
    // 获取默认的行政区划
    getArea() {
      this.$new.post('xzqh/getXzqh.do').then(res => {
        if(res.obj) {
          if(this.xzqhDefault==='320300'){
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = {xzqh_code:'320300',xzqh_name:'不限'};
            this.xzqhArray.splice(0,0, this.items);
          }else{
            res.obj.forEach((item) => {
              if(this.xzqhDefault===item.xzqh_code){
                this.$set(this, 'xzqhArray', [item])
              }
            });
          }
        }
      })
    },
    setTab(type) {
      this.showPad =  true;
      for(let key in this.tab) {
        if(type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false)
        }
        if(this.tab[type]) {
          this.showCover = true
        } else {
          this.showCover = false
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if(type === 'totalPrice') {
        this.$set(this.formData, 'min_price', v.split('-')[0])
        this.$set(this.formData, 'max_price', v.split('-')[1])
      }
      if(type === 'mj') {
        this.$set(this.formData, 'zmjMin', v.split('-')[0])
        this.$set(this.formData, 'zmjMax', v.split('-')[1])
      }
      if(tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        this.showCover = false;
      }
      this.getFirst();
    },
    setValB(type, v) {
      if(this.formData[type] === v) {
        this.$set(this.formData, type, '');
      } else {
        this.$set(this.formData, type, v);
      }
    },
    reset() {
      this.$set(this.formData, 'decoration', '');
      this.$set(this.formData, 'locationLayer', '');
      this.$set(this.formData, 'listDate', '');
      this.$set(this.formData, 'room', '');
      this.$set(this.tab, 'showType', false);
      this.showCover = false;
      this.getFirst()
    },
    confirm() {
      this.$set(this.tab, 'showType', false);
      this.showCover = false;
      this.getFirst()
    },
    // 价格判断
    priceConfirm() {
      if(this.min && this.max) {
        if(this.min > this.max) {
          if(this.priceType === 1) {
            this.$set(this.formData, 'min_price', this.max);
            this.$set(this.formData, 'max_price', this.min);
            this.min = this.formData.min_price;
            this.max = this.formData.max_price;
          } else {
            this.$set(this.formData, 'min_price', this.max * 10000);
            this.$set(this.formData, 'max_price', this.min * 10000);
            this.min = this.formData.min_price / 10000;
            this.max = this.formData.max_price / 10000;
          }
        } else {
          if(this.priceType === 1) {
            this.$set(this.formData, 'max_price', this.max);
            this.$set(this.formData, 'min_price', this.min);
            this.min = this.formData.min_price;
            this.max = this.formData.max_price;
          } else {
            this.$set(this.formData, 'max_price', this.max * 10000);
            this.$set(this.formData, 'min_price', this.min * 10000);
            this.min = this.formData.min_price / 10000;
            this.max = this.formData.max_price / 10000;
          }
        }
        if(this.priceType === 1) {
          this.$set(this.tabText, 'showPrice', this.min + '-' + this.max + '万元');
        } else {
          this.$set(this.tabText, 'showPrice', this.min + '-' + this.max + '万元');
        }
        this.getFirst();
      }
      this.$set(this.tab, 'showPrice', false);
      this.showCover = false;
    },
    changePrice(type) {
      this.priceType = type
    },
  },
};
</script>
<style lang="less" scoped>
.aside{
  position: fixed;
  top: 18vh;
  background-color: #fff;
  right: 0.23rem;
  padding: 0.16rem 0.23rem;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 0.08rem;
  box-shadow: 0 0 0.1rem rgba(0,0,0,0.3);
  p{
    color: #2F72F5;
  }
}
.pad_top{
  padding-top: 1.1rem;
}
.tab_con{
  padding: 0 0.16rem;
  font-size: 0.28rem;
  position: fixed;
  left: 0;
  right: 0;
  border-bottom: 1px solid #E9E9E9;
  z-index: 2;
  background-color: #fff;
  &.fixed{
    position: fixed;
    top: 1.1rem;
    left: 0;
    right: 0;
    border-top: 1px solid #E9E9E9;
  }
  .inner_con{
    .text{
      padding: 0.2rem 0rem;
      text-align: center;
      width: 1.2rem;
      .van-icon{
        transition: all 0.3s;
        color: #CECECE;
        transform: rotate(90deg);
        margin-left: 0.06rem;
        font-size: 0.2rem;
      }
      &.active{
        color: #2F72F5;
        .van-icon{
          transform: rotate(-90deg);
          color: #2F72F5;
        }
      }
    }
    .inner_form{
      background-color: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: calc(100% + 0.02rem);
      max-height: 7.12rem;
      overflow: auto;
    }
    .inner_list{
      padding: 0 0.5rem;
      p{
        line-height: 0.99rem;
        box-sizing: border-box;
        border-bottom: 1px solid #F4F4F4;
        text-align: center;
        &:last-child{
          border: none;
        }
        &.active{
          color: #2F72F5;
        }
      }
    }
    .price_list{
      .price_inner{
        height: 5.92rem;
      }
      .left{
        border-right: 1px solid #f4f4f4;
        width: 45%;
      }
      .right{
        box-sizing: border-box;
        padding-left: 0.2rem;
        max-height: 5.92rem;
        overflow: auto;
      }
      p{
        line-height: 0.99rem;
        box-sizing: border-box;
        border-bottom: 1px solid #F4F4F4;
        text-align: center;
        &:last-child{
          border: none;
        }
        &.active{
          color: #2F72F5;
        }
      }
    }
    .bottom_con{
      height: 1.2rem;
      box-sizing: border-box;
      border-top: 1px solid #f4f4f4;
      padding: 0 0.3rem;
      input{
        width: 1.38rem;
        height: 0.78rem;
        border: 1px solid #f4f4f4;
        text-align: center;
      }
      .tit{
        margin-right: 0.2rem;
      }
      i{
        margin: 0.1rem;
      }
      p{
        margin-left: 0.2rem;
      }
      .van-button{
        height: 0.78rem;
      }
    }
  }
}
.more_list{
  padding: 0 0.3rem 0;
  h4{
    font-size: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .more_con{
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con{
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button{
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset{
        background-color: #EAF1FF;
        color: #2F72F5;
      }
      &.confirm{
        background-color: #2F72F5;
        color: #fff;
      }
    }
  }
  .row_con{
    margin-bottom: 0.54rem;
  }
  span{
    background-color: #F6F6F6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
      border: 1px solid #F6F6F6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active{
      color: #2F72F5;
      background-color: #EAF1FF;
      border: 1px solid #2F72F5;
    }
  }
}
.bm-view{
  height: calc(100vh - 1.1rem);
  position: relative;
}
.map_bottom{
  position: absolute;
  z-index: 2;
  bottom: 0rem;
  width: 100%;
  background-color: #fff;
}
.old_list{
  .inner{
    .inner_l{
      position: relative;
      i{
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24D064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }
    .new_r{
      .tit{
        margin-bottom: 0.08rem;
      }
      .col_gray{
        margin: 0.04rem 0;
      }
      .price{
        h4{
          font-size: 0.34rem;
          color: #FF4532;
          margin-bottom: 0;
          font-weight: 800;
        }
        p{
          font-size: 0.24rem;
          color: #AAAAAA;
          margin-left: 0.12rem;
        }
      }
      .num{
        margin-top: 0.04rem;
        color: #3072F5;
        img{
          width: 0.3rem;
          height: 0.3rem;
        }
        span{
          margin: 0 0.1rem;
          color: #383333;
        }
      }
    }
  }
}
.list_con{
  .inner{
    padding: 0.35rem 0;
    width: 7.04rem;
    margin: 0 auto;
    border-bottom: 1px solid #F4F4F4;
  }
  .banner{
    width: 2.44rem;
    height: 1.84rem;
  }
  .new_r{
    .tel{
      width: 0.36rem;
      height: 0.36rem;
      img{
        width: 100%;
      }
    }
    img{
      width: 100%;
    }
    width: 4.25rem;
    margin-left: 0.3rem;
    .col_gray{
      font-size: 0.24rem;
      color: #505050;
    }
    .tit{
      h4{
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3.4rem;
      }
      i{
        width: 0.6rem;
        line-height: 0.34rem;
        color: #2F72F5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      span{
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24D064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}
.van-overlay{
  z-index: 3;
}
.select_con{
  position: fixed;
  z-index: 9;
  top: calc(0.9rem);
  background-color: #fff;
  left: 0;
  right: 0;
  height: 60vh;
  overflow: auto;
  padding: 0.23rem;
  font-size: 0.26rem;
  .row{
    height: 0.8rem;
    border-bottom: 1px solid #f5f5f5;
    p{
      font-size: #303030;
    }
    span, i{
      color: #A0A0A0;
      font-size: 0.24rem;
    }
  }
}
.map_tit_con{
  padding-top: 0.26rem;
  width: 7.04rem;
  margin: 0 auto 0rem;
  .top{
    margin-bottom: 0.1rem;
    .left{
      h5{
        font-size: 0.32rem;
        font-weight: 800;
        margin-right: 0.1rem;
        max-width: 5rem;
      }
      i{
        font-size: 0.3rem;
      }
    }
    .more{
      color: #999;
    }
  }
  .bottom{
    font-size: 0.24rem;
    i{
      margin: 0 0.06rem;
    }
    p{
      margin-left: 0.18rem;
      span{
        color: #FF4532;
      }
    }
  }
}
</style>